module.exports = __webpack_public_path__ + "img/enterprise.5ee8d61a.svg";